export const consoleIgnoredErrors = ["Extraneous non-props attributes"];

export const BUILDER_IO_TRACE_MARKER = "<BuilderIo>";
